import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useTenant } from '../contexts/TenantContext';
import { clearContextHeader, leftContextTenant } from '../lib/contextTenantScope';

/** Drops a global admin's context workspace as soon as the route leaves it. */
export function useContextTenantScope(): void {
  const { pathname } = useLocation();
  const { contextTenant, setContextTenant } = useTenant();
  useEffect(() => {
    if (contextTenant && leftContextTenant(pathname, contextTenant.slug)) {
      // Header first: clearing the context refetches allowed-pages, which must not still name it.
      clearContextHeader(contextTenant.id);
      setContextTenant(null);
    }
  }, [pathname, contextTenant, setContextTenant]);
}
